<fieldset [formGroup]="skjema">
  <mat-datepicker-toggle matPrefix [for]="datovelger"/>
  <input [matDatepicker]="datovelger" [formControl]="skjema.controls.dato" [placeholder]="datofeltPlaceholder" (focus)="vedFokusMottatt()" (blur)="vedFokusMistet()" class="dato e2e-dato" #datofelt>
  <mat-datepicker #datovelger/>
  <mat-icon fontSet="ion-ios-clock-outline" class="klokkeslettikon mat-icon--ionic-ikon"/>
  <klokkeslett-velger [formControl]="skjema.controls.klokkeslett" placeholder="hh:mm"></klokkeslett-velger>
</fieldset>
